import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-vbacopy-to',
  templateUrl: './page-vbacopy-to.component.html',
  styleUrls: ['./page-vbacopy-to.component.scss']
})
export class PageVBAcopyTOComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
